module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Practice.f67508a8.jpg";